/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthSsoGoogleRequest, AuthSsoGoogleResponse } from '../types/AuthSsoGoogle'

/**
 * POST /auth/sso/google
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::ssoGoogle
 */
export async function authSsoGoogle(
	data: AuthSsoGoogleRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthSsoGoogleResponse>> {
	return axiosInstance.post('/auth/sso/google', data, config)
}
